module.exports = ".document-section {\n  margin-top: 20px; }\n\n.manage-section {\n  margin-top: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/licenses-certifications/steps/cme/continuing-medical-education-screen.component.scss
// module id = 1436
// module chunks = 0